<script setup>
import { Head, Link } from "@inertiajs/vue3";
</script>

<template>
    <Head>
        <title>Error saving gift | Gift Hero Wish Lists</title>
        <meta name="robots" content="noindex" />
    </Head>
    <main class="main" role="main">
        <div
            class="container-wide stacked-children whitespace-bottom whitespace-top"
        >
            <div data-layout="module" data-layout-options="gutters wrap-items">
                <div
                    data-layout="module__item"
                    data-layout-width="one-whole c-one-quarter"
                >
                    <div class="copy-block"></div>
                    <!-- .copy-block -->
                </div>
                <div
                    data-layout="module__item"
                    data-layout-width="one-whole c-one-half"
                >
                    <div class="copy-block">
                        <h1>Error saving gift</h1>
                        <p>
                            We ran into some trouble trying to save your gift.
                            You can try saving your gift again.
                        </p>
                        <p>
                            If you continue to experience this error, please
                            <Link href="/contact-us"
                                >contact us for more help</Link
                            >. Let us know the URL of the gift/product you were
                            trying to save.
                        </p>
                        <p>&mdash; Gift Hero Support</p>
                    </div>

                    <!-- .copy-block -->
                </div>
            </div>
        </div>
        <!-- .container-thin -->
    </main>
    <!-- .main -->
</template>
